/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useEffect, useState } from "react";
import { SimpliCityAdminSDK } from "@simplicitycms/simplicity-admin-js-sdk";
import { useAuth } from "cms/auth/hooks/use-auth";
import { objectHasKeys } from "utils/empty-exists";

const IconLinkItem = (props) => {

    const iconLink = props?.iconLink ?? {};
    const iconUrl = iconLink?.icon ?? "";
    const link = iconLink?.link ?? {};
    const linkGuid = link?.guid ?? "";
    const linkUrl = link?.url ?? "";
    const linkText = link?.text ?? "";

    const { token } = useAuth();
    const [linkData, setLinkData] = useState(null);

    useEffect(() => {
        const load = async () => {
            if (linkGuid) {
                const _link = await SimpliCityAdminSDK.link.findOne(token, linkGuid);
                if (Object.keys(_link).length > 0) {
                    setLinkData(_link);
                }
            }
        };
        if (!linkData) {
            load();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [linkGuid]);

    return (
        <div className='icon-link-item'>
            {objectHasKeys(linkData) && (
                <a href={linkUrl}>
                    {iconUrl &&
                        <img
                            alt='icon'
                            src={iconUrl}
                        />
                    }
                    {linkText}
                </a>
            )}
        </div>
    );
};

export { IconLinkItem };
